import '@/styles/globals.css'
import '@/styles/webflow/normalize.css'
import '@/styles/webflow/webflow.css'
import '@/styles/webflow/az-black-plus.webflow.css'
import '@/styles/webflow/ix-init.css'

import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/manrope/300.css'
import '@fontsource/manrope/400.css'
import '@fontsource/manrope/500.css'
import '@fontsource/manrope/600.css'
import '@fontsource/manrope/700.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return <Component {...pageProps} />
}

export default App
